module.exports = __webpack_public_path__ + "static/media/writersBgDark.2deb93d3.png";